<template>
  <v-flex :class="colWidth">
    <v-container
      class="alert-container"
      ma-0
      pa-0
      fluid
    >
      <v-layout
        my-2
        class="align-center"
        :class="{ 'alert-layout': !outline, 'alert-outline': outline, 'background-color-alert':lightProperty}"
        :style="{ borderColor: outlineborderColor, backgroundColor: bgColor}"
      >
        <v-flex>
          <v-layout>
            <v-flex :class="iconWidth" pl-1 ml-1>
              <v-icon :color="iconColor" :style="{'font-size':(lightProperty && $vuetify.breakpoint.xsOnly) ? '40px' : ''}">
                {{ getIcon() }}
              </v-icon>
            </v-flex>
            <v-flex
              xs10
              pr-1
              mr-1
              class="message py-2"
            >
              {{ message }}
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-flex>
</template>
<script>
import {
  VContainer,
  VLayout,
  VFlex,
  VIcon
} from 'vuetify/lib';
export default {
  components: {
    VContainer,
    VLayout,
    VFlex,
    VIcon
  },
  props: {
    type: {
      type: String,
      default: 'info'
    },
    message: {
      type: String,
      required: true
    },
    iconColor: {
      type: String,
      default: 'primary'
    },
    colWidth: {
      type: String,
      default: 'xs12'
    },
    outline: {
      type: Boolean,
      default: false
    },
    outlineColor: {
      type: String,
      default: null
    },
    iconWidth: {
      type: String,
      default: 'xs2'
    },
    bgColor: {
      type: String,
      default: ''
    }
  },
  computed: {
    outlineborderColor() {
      return this.outline && this.outlineColor ? `var(--v-${this.outlineColor}-base)` : `var(--v-${this.iconColor}-base)`;
    },
    lightProperty(){
      if(this.type == 'light'){
        return true;
      }
      return false;
    }
  },
  methods: {
    getIcon() {
      switch (this.type) {
        case 'error':
          return 'error';
        case 'warning':
          return 'warning';
        case 'success':
          return 'check_circle';
        case 'light':
          return 'emoji_objects'
        default:
          return 'info'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.alert-container {
  .alert-center {
    .message {
      color: var(--v-black-base);
      line-height: 1.38;
    }
  }
  .alert-outline,
  .alert-layout {
    height: auto;
    border-radius: 4px;
  }
  .alert-layout {
    background-color: var(--v-section-base);
  }
  .alert-outline {
    border: 0.5px solid;
  }
  .background-color-alert{
    background: var(--v-primary-variation-1-base);
  }
}
</style>